import { createSlice } from '@reduxjs/toolkit'

// Placeholder Orders Filter slice - will be implemented later
interface OrdersFilterState {
  filterParameters: Record<string, any>
}

const initialOrdersFilterState: OrdersFilterState = {
  filterParameters: {},
}

const ordersFilterSlice = createSlice({
  name: 'ordersFilter',
  initialState: initialOrdersFilterState,
  reducers: {
    setFilterParameters: (state, action) => {
      state.filterParameters = action.payload
    },
    clearFilterParameters: (state) => {
      state.filterParameters = {}
    },
  },
})

export const { setFilterParameters, clearFilterParameters } = ordersFilterSlice.actions
export default ordersFilterSlice.reducer


